const filterQuestions = (questions, filters) => {
  return questions.filter((question) => {
    return Object.keys(filters).every((key) => {
      const filterValue = filters[key]
      const questionValue = question[key]

      if (Array.isArray(filterValue)) return filterValue.includes(questionValue)
      return questionValue === filterValue
    })
  })
}

export default filterQuestions
